function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { memo } from 'react';
import Svg, { Path } from 'react-native-svg';
function CachedIcon(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 22,
    height: 16,
    fill: "none"
    //@ts-ignore
    ,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Path, {
    d: "M11.05 16c-2.233 0-4.133-.775-5.7-2.325C3.783 12.125 3 10.233 3 8v-.175l-1.6 1.6-1.4-1.4 4-4 4 4-1.4 1.4-1.6-1.6V8c0 1.667.588 3.083 1.763 4.25C7.938 13.417 9.367 14 11.05 14c.433 0 .858-.05 1.275-.15.417-.1.825-.25 1.225-.45l1.5 1.5a8.247 8.247 0 01-1.95.825 7.698 7.698 0 01-2.05.275zM18 11.975l-4-4 1.4-1.4 1.6 1.6V8c0-1.667-.587-3.083-1.762-4.25C14.063 2.583 12.633 2 10.95 2c-.433 0-.858.05-1.275.15-.417.1-.825.25-1.225.45l-1.5-1.5A8.25 8.25 0 018.9.275 7.696 7.696 0 0110.95 0c2.233 0 4.133.775 5.7 2.325C18.217 3.875 19 5.767 19 8v.175l1.6-1.6 1.4 1.4-4 4z",
    fill: "#656565"
  }));
}
export default /*#__PURE__*/memo(CachedIcon);
//# sourceMappingURL=index.js.map